import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openNotification } from "src/components/helpers/notification";
import ax from "src/store/config";

const initialState = {
  packetsServicesList: null,
  packetsServicesListLoading: false,
};

export const packetsServicesAction = createAsyncThunk(
  "packetsServicesAction",
  async (payload, { dispatch }) => {
    dispatch(setPacketsServicesListLoading(true));
    try {
      let data;
      switch (payload.flag) {
        case "get":
          ({ data } = await ax.get("api/admin/directory/getTrainingsPacket", {
            params: payload.value,
          }));
          data && dispatch(setPacketsServicesListLoading(false));
          return data;

        case "post":
          ({ data } = await ax.post(
            "api/admin/directory/editTrainingsPacket",
            payload.value
          ));
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно отредактирован`,
            });
          break;

        case "put":
          ({ data } = await ax.put(
            "api/admin/directory/addTrainingsPacket",
            payload.value
          ));
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно добавлен`,
            });
          break;

        case "delete":
          ({ data } = await ax.delete(
            "api/admin/directory/deleteTrainingsPacket",
            { params: payload.value }
          ));
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно удален`,
            });
          break;

        default:
          break;
      }
    } catch (error) {
      dispatch(setPacketsServicesListLoading(false));
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
      return error;
    }
  }
);

const PacketsServicesSlice = createSlice({
  name: "packetsTrainings",
  initialState,
  reducers: {
    setPacketsServicesListLoading: (state, action) => {
      state.packetsServicesListLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(packetsServicesAction.fulfilled, (state, action) => {
      state.packetsServicesList = action.payload;
    });
  },
});

export const { setPacketsServicesListLoading } = PacketsServicesSlice.actions;

export default PacketsServicesSlice.reducer;
